import { css } from '@emotion/react';
import { KeyOf } from '~/types';
import { colors } from './index';

export const mixins = {
  scroll: {
    default: css`
      &::-webkit-scrollbar {
        width: 5px; /* 스크롤바의 너비 */
      }

      &::-webkit-scrollbar-thumb {
        height: 30%; /* 스크롤바의 길이 */
        border-radius: 10px;
        background: ${colors.neutral100}; /* 스크롤바의 색상 */
      }

      &::-webkit-scrollbar-track {
        background: transparent; /*스크롤바 뒷 배경 색상*/
      }
    `,
    dropdown: css`
      &::-webkit-scrollbar {
        width: 5px; /* 스크롤바의 너비 */
      }

      &::-webkit-scrollbar-thumb {
        height: 30%; /* 스크롤바의 길이 */
        border-radius: 10px;
        background: ${colors.neutral700}; /* 스크롤바의 색상 */
      }

      &::-webkit-scrollbar-track {
        width: 20px;
        background: transparent; /*스크롤바 뒷 배경 색상*/
      }
    `,
    none: css`
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
      }
    `,
    horizontal: css`
      &::-webkit-scrollbar {
        height: 3px; /* 스크롤바의 너비 */
      }

      &::-webkit-scrollbar-thumb {
        /* height: 10%; 스크롤바의 길이 */
        border-radius: 10px;
        background: ${colors.neutral100}; /* 스크롤바의 색상 */
      }

      &::-webkit-scrollbar-track {
        /* background: transparent; 스크롤바 뒷 배경 색상 */
      }
    `,
  },
  text: {
    select_on: css`
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    `,
    select_off: css`
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `,
    ellipsis_1: css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `,
    ellipsis_2: css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
    `,
  },
  /**
   * aspect ratio 안먹힐때 참고
   * https://stackoverflow.com/questions/68886003/css-aspect-ratio-not-working-in-safari-browser
   */
  aspectRatio: {
    ratio1_1: css`
      aspect-ratio: 1/1;
      @supports not (aspect-ratio: 1 / 1) {
        &::before {
          content: '';
          padding-top: 100%;
          float: left;
        }

        &::after {
          content: '';
          display: block;
          clear: both;
        }
      }
    `,
    ratio5_6: css`
      aspect-ratio: 5/6;
      @supports not (aspect-ratio: 5 / 6) {
        &::before {
          content: '';
          padding-top: 120%;
          float: left;
        }

        &::after {
          content: '';
          display: block;
          clear: both;
        }
      }
    `,
    ratio4_3: css`
      aspect-ratio: 4/3;
      @supports not (aspect-ratio: 4 / 3) {
        &::before {
          content: '';
          padding-top: 75%;
          float: left;
        }

        &::after {
          content: '';
          display: block;
          clear: both;
        }
      }
    `,
    ratio3_4: css`
      aspect-ratio: 3/4;
      @supports not (aspect-ratio: 3 / 4) {
        &::before {
          content: '';
          padding-top: 125%;
          float: left;
        }

        &::after {
          content: '';
          display: block;
          clear: both;
        }
      }
    `,
  },
} as const;

export type Mixins = typeof mixins;
export type MixinKeys = KeyOf<typeof mixins>;
